import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import Swal from 'sweetalert2'
import { useSelector, shallowEqual } from 'react-redux'
import { AddPost } from '../api'

function CoachFeedModal({ show, handleClose, setSnackbar, handleGetPost}) {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  // const inpRef = useRef();
  // const [key, setKey] = useState(Date.now())
  const [form, setForm] = useState({
    title: null,
    description: null,
    image: null,
    preview: null
  })
  const [pending, setPending] = useState(false);
  useEffect(()=>{
    setForm({
      title: null,
      description: null,
      image: null,
      preview: null
    })
  }, [show])

  // useEffect(()=>{
  //   if(!form.image){
  //     setKey(Date.now())
  //   }
  // }, [form.image])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if(!form.title || form.title == ''){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Enter Post Title',
      })
      return ;
    }
    if(!form.description || form.description == ''){
      // setSnackbar({
      //   isOpen: true,
      //   message: 'Enter Description',
      //   type: 'error'
      // })
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Enter Post Description',
      })
      return ;
    }
    if(!form.image){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Select Post Image',
      })
      // setSnackbar({
      //   isOpen: true,
      //   message: 'Select image',
      //   type: 'error'
      // })
      return ;
    }

    try{
      setPending(true);
      let formData = new FormData();
      formData.append('title', form.title)
      formData.append('description', form.description)
      formData.append('image', form.image)
      formData.append('userId', user.id)

      let res = await AddPost(formData);
      setSnackbar({
        isOpen: true,
        message: res.message,
        type: 'success'
      })
      handleGetPost();
      handleClose();
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
      })
    }finally{
      setPending(false);
    }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop={pending ? 'static' : true}>
        <Modal.Header className=" d-flex justify-content-between align-items-center ">
          <Modal.Title>Add Post</Modal.Title>
          <button
            className="bg-transparent border-0 btnSize icon "
            onClick={handleClose}
            disabled={pending}
          >
            <RxCross2 />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              {/* <Form.Label>Email address</Form.Label> */}
              <Form.Control
                type="text"
                size="lg"
                placeholder="Please Enter Title"
                autoFocus
                value={form.title}
                onChange={(e)=>{
                  e.persist();
                  setForm((pre)=>({
                    ...pre,
                    title: e.target.value
                  }))
                }}
              />
            </Form.Group>

            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              {/* <Form.Label>Example textarea</Form.Label> */}
              <Form.Control
                size="lg"
                type="text"
                placeholder="Please Enter Description"
                autoFocus
                value={form.description}
                onChange={(e)=>{
                  e.persist();
                  setForm((pre)=>({
                    ...pre,
                    description: e.target.value
                  }))
                }}
              />
            </Form.Group>
          </Form>
          {form.preview && <div className="position-relative">
            <button className="position-absolute cross-btn"
              onClick={()=>{
                setForm((pre)=>({
                  ...pre,
                  image: null,
                  preview: null
                }))
              }}
            >X</button>
            <img src={form.preview} width={'100%'} />
          </div>}
        </Modal.Body>
        <Modal.Footer>
          {!form.image && <Button variant="primary">
            <label htmlFor="file-upload" className="custom-file-upload">
              Choose Image
            </label>
            <input id="file-upload" accept="image/png, image/webp, image/jpeg"  type="file" onChange={(e)=>{
              if(e.target.files.length > 0){
                let file = e.target.files[0];
                if(file){
                  console.log(file);
                  setForm((pre)=>({
                    ...pre,
                    image: file,
                    preview: URL.createObjectURL(file)
                  }))
                }
                // console.log(URL.createObjectURL(e.target.files[0]));
                
                // setKey(Date.now())
              }
            }}
            // onClick={e => (e.target.value = null)}
            />
          </Button>}

          <Button variant="primary" type="submit" disabled={pending} onClick={handleSubmit}>
            {pending ? <div
                class="spinner-border text-white mx-auto"
                role="status"
              ></div> : 'Save Changes'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CoachFeedModal;
